function gettable4(state){
    let result = [];
    let sourceName = "";
    let index = "";
    let j = 0;

    for(let key in state.objects.ndt){
        sourceName = `Источник ${j+1} (труба от вращающейся печи "${state.objects.ndt[key].name.value}")`;
        for(let i = 0; i < criticalNDT.length; i++){
            if(i === 0) {
                index = "1";
            }
            else {
                index = "";
            }

            if(state.objects.ndt[key].ndtres[criticalNDT[i]] !== "4"){
                let value = criticalNDTvalue[criticalNDT[i]][getNDTValueCode(state.objects, key, criticalNDT[i])];
                //result.push([index, sourceName, 1, "т/сут", "", criticalNDTtexts[criticalNDT[i]], classNDTdanger[criticalNDT[i]], "мг/нм<sup>3</sup>", value, "мг/нм<sup>3</sup>", "", "нм<sup>3</sup>/год", "", "", "", ""]);
                result.push([index, sourceName, 1, "т/сут", "", criticalNDTtexts[criticalNDT[i]], classNDTdanger[criticalNDT[i]], "мг/нм<sup>3</sup>", value, "мг/нм<sup>3</sup>", state.objects.ndt[key].ndtValue[criticalNDT[i]].value, "нм<sup>3</sup>/год", "", "", "", ""]);
            } 
        }
        j++;
         
    } 

    return result;
} 


const criticalNDT = ["ndt8", "ndt10", "ndt11", "ndt12", "ndt13"];

const criticalNDTtexts = {
    ndt8: 'Пыль неорганическая с содержание SiO<sub>2</sub> менее 20%',
    ndt10: 'NO<sub>x</sub>',
    ndt11: 'NH<sub>3</sub>',
    ndt12: 'SO<sub>2</sub>',
    ndt13: 'CO'
}

const criticalNDTvalue = {
    ndt8: {
        "1": '⩽25',
        "2": '⩽50',
        "3": '⩽500',
        "4": '⩽1000'
    } ,
    ndt10: {
        "1": '⩽500',
        "2": '⩽800',
        "3": '⩽500'
    },
    ndt11: {
        "1": '⩽50'    
    },
    ndt12: {
        "1":'⩽400',
    } ,
    ndt13: {
        "1": '⩽600'
    }
}



const classNDTdanger = {
    ndt8: 3,
    ndt10: 3,
    ndt11: 4,
    ndt12: 3,
    ndt13: 4
}

export default gettable4;
